import React, { useState } from 'react'
import { Icon, Popover } from 'antd'
import { useTranslation } from 'react-i18next'
import BreadcrumbHiddenList from '../styles/breadcrumbEllipsisStyle'
import { translateTagName } from '../../campaignManager/hooks/contentManager/useLibraryContents'

// The "…" that stands in for the collapsed middle folders of a breadcrumb path.
// Two modes, picked by whether `onNavigate` is provided:
//   - navigable (onNavigate given): opens on click, folders are clickable links;
//   - informational (no onNavigate): opens on hover, the list is read-only.
// Render it INSIDE a <Breadcrumb.Item> so antd still handles the separators.
const BreadcrumbEllipsis = ({ hidden = [], onNavigate, className }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const navigable = typeof onNavigate === 'function'

  const content = (
    <BreadcrumbHiddenList className={navigable ? '' : 'read-only'}>
      {hidden.map((folder) => (
        <div
          key={folder.id}
          className="bc-hidden-item"
          onClick={
            navigable
              ? () => {
                  setOpen(false)
                  onNavigate(folder)
                }
              : undefined
          }
        >
          <Icon type="folder" />
          {translateTagName(folder.name, t)}
        </div>
      ))}
    </BreadcrumbHiddenList>
  )

  const popoverProps = navigable
    ? { trigger: 'click', visible: open, onVisibleChange: setOpen }
    : { trigger: 'hover' }

  return (
    <Popover content={content} placement="bottom" {...popoverProps}>
      <span className={className}>…</span>
    </Popover>
  )
}

export default BreadcrumbEllipsis
